module.exports = __webpack_public_path__ + "img/电子邮箱@2x.d7f8e28a.png";